import { cacheGet, cacheSet, emitCacheUpdated } from '../../utils/cache';
import { mergeAttendance } from '../../utils/attendanceMerge';

// Normalise le "day" quel que soit le shape backend (day | attendance_day)
function pluckDay(payload) {
  if (!payload) return null;
  return payload.day || payload.attendance_day || payload;
}

// Convertit un "day" backend en ligne attendance CabConnect (le backend renvoie déjà les champs)
function toRow(day) {
  if (!day) return null;
  return {
    id: day.id,
    local_date: day.local_date,
    operator_id: day.operator_id || day.operator?.id,
    operator: day.operator || null,
    check_in: day.check_in,
    check_out: day.check_out,
    break_start: day.break_start,
    break_end: day.break_end,
    work_minutes: day.work_minutes ?? (day.work_hours != null ? Math.round(Number(day.work_hours) * 60) : null),
    break_minutes: day.break_minutes ?? (day.break_hours != null ? Math.round(Number(day.break_hours) * 60) : null),
    anomalies: day.anomalies || [],
    locked: !!day.locked,
    updated_at: day.updated_at || null,
  };
}

export function handleAttendanceUpsert(payload) {
  const day = pluckDay(payload);
  const row = toRow(day);
  if (!row || !row.id) return;

  // Merge dans le cache
  const existing = cacheGet('activity/attendance', []);
  const merged = mergeAttendance(existing, [row]);
  cacheSet('activity/attendance', merged);
  emitCacheUpdated('activity/attendance');
}

export function handleAttendanceCreated(payload) {
  handleAttendanceUpsert(payload);
}

export function handleAttendanceLocked(payload) {
  handleAttendanceUpsert(payload);
}

// Punch NFC → on réutilise le "attendance_day" renvoyé
export function handlePunchCreated(payload) {
  handleAttendanceUpsert(payload);
}
